




















































import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { RobotOption } from '@/models/MetaTags';

@Component({
    components: {
    },
    metaInfo() {
        return {
            title: this.$i18n.t("notFound.title").toString(),
            meta: [
                { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') }
            ]
        };
    }
})
export default class NotFound extends Vue {

}
